import { render } from "./FormView.vue?vue&type=template&id=07bcdd6c&scoped=true"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=07bcdd6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07bcdd6c"

export default script